// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__xhPds","container":"Footer_container__UFYzc","privacy":"Footer_privacy__ReEHs","poweredBy":"Footer_poweredBy__aVgyG"};